module.exports = __webpack_public_path__ + "static/img/3.1ad76d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/3.png
// module id = EEwh
// module chunks = 0